export enum RequestsView {
  MyRequests = "my_redaction_requests",
  AssignedRequests = "assigned_redaction_requests",
  AllRequests = "all_redaction_requests",
  ArchivedRequests = "archived_redaction_requests",
}
